<script setup>
import { contacts } from '@/actions/App/Http/Controllers/PageController'
</script>

<template>
    <div class="rounded-4xl bg-black/50">
        <div class="px-6 py-24 sm:px-6 sm:py-20 lg:px-8">
            <div class="mx-auto max-w-2xl text-center">
                <h2 class="font-chivo text-4xl font-semibold tracking-tight text-balance text-white sm:text-5xl">
                    Pojďme se sejit!
                </h2>
                <p class="mx-auto mt-6 max-w-xl text-lg/8 text-pretty text-gray-200">
                    Pokud máte zájem o naše služby, neváhejte nás kontaktovat. Rádi vám poskytneme více informací a
                    zodpovíme vaše dotazy.
                </p>
                <div class="mt-10 flex items-center justify-center gap-x-6">
                    <Link
                        class="bg-brand-orange border-brand-orange hover:bg-brand-orange/80 w-full cursor-pointer rounded-full border px-5 py-4 text-center text-white backdrop-blur-3xl transition-all duration-150 ease-in-out xl:py-2"
                        :href="contacts.url() + '#kontaktni-formular'"
                        aria-label="Kontaktní formulář"
                    >
                        Kontaktní formulář
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>
